// extracted by mini-css-extract-plugin
module.exports = {"sync":"SyncStatus-module--sync--20AER","text":"SyncStatus-module--text--1k63-","status":"SyncStatus-module--status--2DT68"};